'use client'

import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-regular-svg-icons/faBars";
import MobileNavigationWrapper from "@/components/navigation/mobile-wrapper";
import { usePathname } from "next/navigation";
import MobileNavigation from "@/components/navigation/mobile";
import {StrapiMenu} from "@/app/types/strapi.types";

export default function MenuToggle({menu, textClass} : {menu: StrapiMenu, textClass: string}) {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const pathname = usePathname()

    useEffect(() => {
        setMobileMenuVisible(false);
    }, [pathname]);

    return (
        <>
            <div
                className={"lg:hidden text-2xl pr-3"}
                onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
            >
                <FontAwesomeIcon icon={faBars} className={`relative top-[5px] ${textClass}`} />
            </div>
            {mobileMenuVisible && (
                <div className={"fixed top-0 h-screen left-0 right-0 z-[5001] overflow-auto overflow-x-hidden bg-white xl:hidden"}>
                    <MobileNavigationWrapper setMobileMenuVisible={() => setMobileMenuVisible(!mobileMenuVisible)}>
                        <MobileNavigation menu={menu} />
                    </MobileNavigationWrapper>
                </div>
            )}
        </>
    );
}
